module.exports = __webpack_public_path__ + "img/website-service-09.a32f0559.png";